module.exports = __webpack_public_path__ + "static/media/logo.89d04d46.png";